<template>
	<div v-loading="loading">
		<div class="search">
			<el-form class="searchform" ref="form" :model="searchform" label-width="80px" label-position="left">
				<el-form-item label="快速搜索">
					<el-input @input="getdata" placeholder="請輸入戶主代號/姓名/身份證號碼/電話等......" v-model="searchform.keyword" clearable>
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
						<!-- <el-button @click="getdata" slot="append" icon="el-icon-search"></el-button> -->
					</el-input>
				</el-form-item>
			</el-form>


		</div>
		<div class="pagemain">
			<div class="pagetablebox">
				<el-table  ref="chooseusertable" empty-text="暫無數據" :data="data" border
				 :header-cell-style="{background:'#FAFAFA'}">
					
					<el-table-column width="200" prop="code" label="戶主代號" align="center">
						<template slot-scope="scope">
							<div class="phonecel">戶主代號</div>
							<div>{{scope.row.code}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="姓名" align="center">
						<template slot-scope="scope">
							<div class="phonecel">姓名</div>
							<div>{{scope.row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="card" label="身份證號碼" align="center">
						<template slot-scope="scope">
							<div class="phonecel">身份證號碼</div>
							<div>{{scope.row.card}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="num" label="持有卡數" align="center">
						<template slot-scope="scope">
							<div class="phonecel">持有卡數</div>
							<div>{{scope.row.num}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="money" label="合計餘額(HKD)" align="center">
						<template slot-scope="scope">
							<div class="phonecel">合計餘額(HKD)</div>
							<div>{{scope.row.money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="phone" label="聯系電話" align="center">
						<template slot-scope="scope">
							<div class="phonecel">聯系電話</div>
							<div>{{scope.row.phone}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<div class="phonecel">操作</div>
							<el-button size="mini" @click="choose(scope.row)">導入</el-button>
						</template>

					</el-table-column>
				</el-table>
			</div>
			<div style="margin-top: 20px">
				
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "chooseholder",
		
		data() {
			return {
				loading: false,
				mso_id:0,
				data: [],
				searchform: {},
			}
		},

		methods: {
			
			choose(row) {
				this.$emit('closeholder',row);
			},
			
			getdata(){
				this.post('/api/bank/bank_holder', {
					pagesize:20,
					mso_id:this.mso_id,
					keyword:this.searchform.keyword,
				}).then((res) => {
					this.data = res.info;
				}).catch((err) => {
				
					console.log(err)
				})
			},
		},
		created() {
			this.mso_id = sessionStorage.getItem('mso_id');
			this.getdata();
		}




	}
</script>

<style>


</style>